import { memo } from 'react';

import classNames from 'classnames';

import { createDesign, useTrans } from '@/hooks';

import Image from '../image';
import './index.scss';

const { prefixCls } = createDesign('cmp-info-card');

interface Props {
  avatar?: string;
  name?: string;
  desc?: string;
  buttonAttrs?: any;
  className?: string;
}

function InfoCard({ avatar, name, desc, className, buttonAttrs }: Props) {
  const { t } = useTrans();
  return (
    <div className={classNames(prefixCls, className)}>
      <div className={`${prefixCls}-info`}>
        {avatar && <Image type="Avatar" className={`${prefixCls}__avatar`} url={avatar} />}
        <div className={`${prefixCls}__msg`}>
          <span className={`${prefixCls}__name`}>{name}</span>
          <div className={`${prefixCls}__desc`}>{desc}</div>
        </div>
      </div>
      {buttonAttrs && (
        <div className={`${prefixCls}__btn`} {...buttonAttrs}>
          {t(buttonAttrs?.text)}
        </div>
      )}
    </div>
  );
}

export default memo(InfoCard);
